var OwnershipErrorCodes;
(function (OwnershipErrorCodes) {
    OwnershipErrorCodes["InvalidParam"] = "PBOWN1033E";
    OwnershipErrorCodes["AmountNotInteger"] = "PBOWN1034E";
    OwnershipErrorCodes["EmptyCurrency"] = "PBOWN1035E";
    OwnershipErrorCodes["InvalidReason"] = "PBOWN1036E";
    OwnershipErrorCodes["InvalidJSON"] = "PBOWN1037E";
    OwnershipErrorCodes["AdminUserUuidNotRetrievable"] = "PBOWN1038E";
    OwnershipErrorCodes["InvalidCurrency"] = "PBOWN1039E";
    OwnershipErrorCodes["SystemWalletNotRetrievable"] = "PBOWN1040E";
    OwnershipErrorCodes["UserWalletNotRetrievable"] = "PBOWN1041E";
    OwnershipErrorCodes["TransferCreationError"] = "PBOWN1042E";
    OwnershipErrorCodes["MissingAuthToken"] = "PBOWN1043E";
    OwnershipErrorCodes["AmountGreaterThanBalance"] = "PBOWN1063E";
})(OwnershipErrorCodes || (OwnershipErrorCodes = {}));
export default OwnershipErrorCodes;
